module.exports = __webpack_public_path__ + "img/ep-M.adc51387.jpg";